// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { warning } from 'react-notification-system-redux'
import handleLeave from 'redux/modules/pathDetails/thunks/handleLeave'

// NOTE - we return null here to tell the caller that setCurrentPath failed.

const sendUserBackAndProvideWarning = message => async dispatch => {
  await dispatch(handleLeave())
  await dispatch(warning({ message }))
  return null
}

export default sendUserBackAndProvideWarning
